import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { DataGridsHelper } from 'src/app/core/data-grids-helper';
import { MorayWestInstructionsGridDTO } from 'src/app/core/Dtos/moray-west/instructions-grid-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { BaseComponent } from 'src/app/features/base-component';

@Component({
    selector: 'app-moray-west-instructions',
    templateUrl: './moray-west-instructions.component.html',
    styleUrl: './moray-west-instructions.component.scss',
    standalone: false
})
export class MorayWestInstructionsComponent extends BaseComponent {
  @Output() 
  public OnViewInstruction : EventEmitter<string | number> = new EventEmitter<string | number>();

  @Input("GridData")
  public set CurrentSearchData(data : MorayWestInstructionsGridDTO[])
  {
    this.DataGridHelper.GridData = data;
  }

  public DataGridHelper: DataGridsHelper<MorayWestInstructionsGridDTO> = new DataGridsHelper<MorayWestInstructionsGridDTO>();
    
  
  constructor(    
      dateFormatHelper: DateFormatHelperService,
      oktaService: OktaService,
      private _router: Router,
      alertService: AlertsService) 
  {
    super(oktaService, alertService, dateFormatHelper)
  }
  
  public ViewInstruction(instructionId:number|string){
    this.OnViewInstruction?.next(instructionId);
  }

  public CopyToNew(instructionId: number | string) {
    let viewingRoute = `mowwl-new/${instructionId}`;
    this._router.navigate([viewingRoute]);
  }

  public GetClass(startDate: Date | string, endDate: Date | string, appliedInPPA: boolean): string {
    let sd = new Date(startDate),
      ed = (endDate ?? "") == "" ? null: new Date(endDate),
      today = new Date(),
      css = "";
    
    if (today > sd && (ed == null || today < ed))
      css = "day-instruction";

    if (appliedInPPA)
      css += " applied-in-ppa";

    return css;
  }
}
